// extracted by mini-css-extract-plugin
export default {"dashboardSettings":"styles_dashboardSettings__tjbQL","layout":"styles_layout__qd7TS"};